// Copyright © 2021 Move Closer
import { abstractImageProps } from '../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapImageProps = {
    ...abstractImageProps,
    fallback: {
        type: String,
        required: false
    },
    loading: {
        type: String,
        required: false
    },
    sizes: {
        type: String,
        required: false
    },
    srcset: {
        type: String,
        required: false
    }
};
